import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import usersActionCreators from './users';
import phonesActionsCreators from '../../phones/action-creators';
import notificationsActionsCreator from '../../notifications/action-creators';

const userPhonesActionsCreators = {
  updateUserPhones(formData) {
    const patchData = {
      data: formData.phones,
      patched: 'phones',
    };
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateUserPhones'));
      const data = await ApiService.patch(`/api/v1/users/${formData.userGuid}`, patchData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateUserPhones'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateUserPhonesSuccess(data));
      }
    };
  },
  updateUserPhonesSuccess(updated) {
    return (dispatch) => {
      dispatch(usersActionCreators.replaceUser(updated.data));
      // This action handles success for both add and edit, so make sure we dispatch
      //   to reset both related state keys
      dispatch(phonesActionsCreators.resetPhoneState());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('User phones updated'))
    };
  },
};

export default userPhonesActionsCreators;
